<template>
  <v-dialog :value="value"
            :max-width="maxWidth"
            persistent
            :content-class="`modal modal-round ${contentClass}`"
            ref="modal"
            @input="emitInput">

    <div v-if="closeable"
         class="close"
         @click="hideModal">&times;</div>

    <template slot="activator">
      <slot name="activator"></slot>
    </template>

    <v-card class="modal-body"
            :class="{'has-padding': hasPadding}"
            style="">

      <div class="modal-body-header">
        <i class="modal-body-header-back mdi mdi-chevron-left pointer"
           v-if="back"
           @click="emitBack"></i>
        <h1 v-if="title"
            class="modal-body-title">{{ title }}</h1>
        <slot name="header"/>    
      </div>

      <div class="modal-body-content" :class="{'no-scroll': noScroll}">
        <slot />
      </div>

      <div class="modal-footer">
        <slot name="footer" />
      </div>
    </v-card>

  </v-dialog>
</template>

<script>
export default {
  components: {},

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
    closeable: {
      type: Boolean,
      default: true,
    },
    maxWidth: {
      type: [Number, String],
      default: 800,
    },
    contentClass: {
      type: String,
      default: undefined,
    },
    back: {
      type: Boolean,
      default: false,
    },
    hasPadding: {
      type: Boolean,
      default: true,
    },
    noScroll: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      drag: false,
    };
  },

  watch: {
    value(val) {
      if(this.closeable) {
        if (val) {
          document.addEventListener("mousedown", this.dragToFalse);
          document.addEventListener("mousemove", this.dragToTrue);
          document.addEventListener("mouseup", this.closeModal);
        } else {
          document.removeEventListener("mousedown", this.dragToFalse);
          document.removeEventListener("mousemove", this.dragToTrue);
          document.removeEventListener("mouseup", this.closeModal);
        }
      }
    },
  },

  methods: {
    emitInput(value) {
      this.$emit("input", value);
    },
    hideModal() {
      this.emitInput(false);
    },
    emitBack() {
      this.$emit("back");
    },
    dragToTrue() {
      this.drag = true;
    },
    dragToFalse() {
      this.drag = false;
    },
    closeModal(event) {
      try {
        if (event.target.className.includes("v-overlay") && !this.drag) {
          this.hideModal();
        }        
      } catch (error) {
        console.log(error)
      }
    },
  },

  computed: {},

  mixins: [],
};
</script>

<style lang="scss" scoped>
.modal {
  .has-padding {
    padding: 40px;
  }
  .modal-body {
    display: flex;
    flex-direction: column;
    flex: 1;

    .modal-body-header {
      position: relative;

      .modal-body-header-back {
        position: absolute;
        font-size: 30px;
        top: 50%;
        transform: translateY(-50%);
      }

      .modal-body-title {
        color: #3b3b3b;
        font-weight: 600;
        margin-bottom: 28px;
        text-align: center;
        text-wrap: wrap;
        line-height: 1.2em;
      }
    }

    .modal-body-content {
      overflow-y: scroll;
      padding: 5px 0;
      border-radius: 0;
    }

    .no-scroll {
      overflow-y: visible !important;
    }
  }

  .modal-footer {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
}
</style>
